<template>
  <div id="visitor-service-list" class="apply-list ht-scroll-vertical" ref="visitorServiceList">
    <form action="javascript:void(0)" >
      <van-search
          background="#0a90f7"
          v-model="keyword"
          placeholder="请输入搜索关键词"
          @search="debounceOnSearch"
          :clearable="false"
      />
    </form>
    <div class="list portrait-list flex" v-if="!showEmpty">
      <van-pull-refresh v-model="loading" @refresh="onSearch" >
            <van-list
                v-if="!showEmpty"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
            >
              <div class="s-grid-box">
                <ServiceItemPortrait v-for="(item,index) in list" :key="index" :service="item"/>
              </div>
            </van-list>
      </van-pull-refresh>
    </div>
    <div class="empty-container" v-else>
      <Error type="empty"/>
    </div>
  </div>
</template>
<script>
import {List, Cell, Search, Toast} from 'vant'
import {debounce} from 'lodash-es'
import App from "@/App";
import { queryServices } from "@/api/service-hall";

export default {
  name: 'visitorServiceList',
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Search.name]: Search,
    ServiceItemPortrait: () => import("@/components/ServiceHall/ServiceItemPortrait"),
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      error: false,
      params:{
        pageSize: 30,
        related: true
      },
      pageIndex: 0,
      totalPage: 0,
      userId: null,
      keyword: '',
      showEmpty:false,
    }
  },
  computed: {},
  created() {
    this.mixinShowLoading()
    this.debounceOnSearch = debounce(this.onSearch, 100)
  },
  beforeRouteUpdate(to, from, next) {
    this.$refs.visitorServiceList.scrollTop = 0
    this.list = []
    this.pageIndex = 0
    this.loading = true
    this.finished = false
    this.onLoad()
    this.mixinShowLoading()
    next()
  },
  methods: {
    onLoad() {
      this.error = false
      let param = this.params;
      param.pageIndex = this.pageIndex;
      param.keyword = this.keyword;
      queryServices(param).then(response => {
        if(200 == response.code){
          var resp = response.data;
          if (!resp.total || resp.data.length < 0) {
            this.showEmpty = true;
            this.finished = true;
            return;
          }
          this.list = this.list.concat(resp.data)
          if (this.list.length >= resp.total) this.finished = true
          this.totalPage = resp.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          } else {
            this.pageIndex++;
          }
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
        Toast.fail('服务器繁忙或网络异常，请稍后重试')
      }).finally(() => {
        this.mixinClearLoading()
      })
    },
    onSearch() {
      this.$refs.visitorServiceList.scrollTop = 0
      this.list = []
      this.pageIndex = 0
      this.loading = true
      this.finished = false
      this.onLoad()
      this.mixinShowLoading()
    },
  }
}
</script>

<style scoped lang="scss">
.apply-list,.empty-container {
  height: 100vh;
}
.van-search__content{
  background-color: #0a90f7;
  border: 1px solid #f0f0f0;
  border-radius: 18px;

}
.van-cell,.van-cell__value--alone {
  color: #fff;
}

.list{
  &.portrait-list{
    background: #ffffff;
    .van-list {
      .s-grid-box{
        padding: 0 10px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }
    .service-name{
      height: 44px;
      line-height: 22px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
    }
  }
  &.landscape-list{
    .van-list{
      padding:15px;
    }
  }
}
</style>
<style>
#visitor-service-list .van-field__control {
  color: #ffffff;
}
#visitor-service-list .van-field__control::placeholder {
  color: #ffffff;
  font-weight: 400;
}

</style>
